"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _Modal = require("../Modal");

var _Card = require("../Card");

var _Typography = require("../Typography");

var _TextButton = require("../TextButton");

var _jsxRuntime = require("react/jsx-runtime");

var StyledCardContent = (0, _material.styled)(_Card.Card.Content)(function (_ref) {
  var theme = _ref.theme;
  return {
    paddingTop: theme.spacing(6)
  };
});
var StyledCardActions = (0, _material.styled)(_Card.Card.Actions)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    padding: theme.spacing(4)
  };
});

var ConfirmationModal = function ConfirmationModal(_ref3) {
  var cancelLabel = _ref3.cancelLabel,
      confirmLabel = _ref3.confirmLabel,
      open = _ref3.open,
      title = _ref3.title,
      subtitle = _ref3.subtitle,
      onClose = _ref3.onClose,
      onConfirm = _ref3.onConfirm;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
    onClose: onClose,
    open: open,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCardContent, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
            component: "h1",
            gutterBottom: true,
            variant: "h4",
            children: title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
            component: "h2",
            children: subtitle
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledCardActions, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, {
          label: cancelLabel,
          onClick: onClose,
          variant: "outlined"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, {
          label: confirmLabel,
          onClick: onConfirm
        })]
      })]
    })
  });
};

var _default = ConfirmationModal;
exports.default = _default;